import { Component, Input } from '@angular/core';
import { FundedSummary } from '../../../../domain/model/executive-snapshot.model';

/** Full-width funded hero: period title, amount + deals, activation/residual split and the YoY pace line. */
@Component({
  selector: 'ifbp-funded-hero-card',
  templateUrl: './funded-hero-card.component.html',
  styleUrls: ['./funded-hero-card.component.scss'],
  standalone: false,
})
export class FundedHeroCardComponent {
  /** "month to date" | "quarter to date" | "year to date" | "Jul 1 – Jul 27, 2026". */
  @Input() periodTitle: string;
  @Input() funded: FundedSummary;
  @Input() paceLine: string;

  readonly dealsPlural = { '=1': '1 deal', other: '# deals' };
}
